import React, { FC, ReactNode } from 'react'
import './GrowlAlertMessage.scss'

const GrowlAlertMessage: FC<{ title: ReactNode | string; message: ReactNode | string }> = ({ title, message }) => (
  <div className="growl-alert-message">
    <div className="growl-alert-message__title">{title}</div>
    <div className="growl-alert-message__message">{message}</div>
  </div>
)

export default GrowlAlertMessage
